(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/product-start-page/views/promos/default-promo-info-bar-price.js') >= 0) return;  svs.modules.push('/components/app/product-start-page/views/promos/default-promo-info-bar-price.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.product_start_page=_svs.app.product_start_page||{};
_svs.app.product_start_page.templates=_svs.app.product_start_page.templates||{};
svs.app.product_start_page.templates.default_promo_info_bar_price = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"rounds-header-column\"><span class=\"align-middle\">"
    + container.escapeExpression((lookupProperty(helpers,"formatCurrency")||(depth0 && lookupProperty(depth0,"formatCurrency"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"formatCurrency","hash":{},"data":data,"loc":{"start":{"line":1,"column":61},"end":{"line":1,"column":81}}}))
    + " kr</span></div>";
},"useData":true});
Handlebars.partials['components-app-product_start_page-default_promo_info_bar_price'] = svs.app.product_start_page.templates.default_promo_info_bar_price;
})(svs, Handlebars);


 })(window);